var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content" }, [
    _c(
      "div",
      { staticClass: "tabs-container" },
      [
        _c(
          "el-tabs",
          {
            staticStyle: { width: "100%", height: "100%" },
            attrs: { type: "card" },
            on: { "tab-click": _vm.handleTabClick },
            model: {
              value: _vm.activeTabName,
              callback: function($$v) {
                _vm.activeTabName = $$v
              },
              expression: "activeTabName"
            }
          },
          [
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_UserManagement"),
                  name: "userManage"
                }
              },
              [
                _c("user-manage", {
                  ref: "userManage",
                  attrs: {
                    "tab-title": _vm.$t("CargoMsg.Cargo_UserManagement")
                  }
                })
              ],
              1
            ),
            _c(
              "el-tab-pane",
              {
                staticStyle: { width: "100%", height: "100%" },
                attrs: {
                  lazy: true,
                  label: _vm.$t("CargoMsg.Cargo_RoleUserSettings"),
                  name: "userRoleManage"
                }
              },
              [
                _c("user-role-manage", {
                  ref: "userRoleManage",
                  attrs: {
                    "tab-title": _vm.$t("CargoMsg.Cargo_RoleUserSettings")
                  }
                })
              ],
              1
            ),
            _vm.useUserPort
              ? _c(
                  "el-tab-pane",
                  {
                    staticStyle: { width: "100%", height: "100%" },
                    attrs: {
                      lazy: true,
                      label: _vm.$t(
                        "SystemMaintenance.AssociatedRoutesAndPorts"
                      ),
                      name: "associatedPort"
                    }
                  },
                  [
                    _c("user-port-tab", {
                      ref: "associatedPort",
                      attrs: {
                        "tab-title": _vm.$t(
                          "SystemMaintenance.AssociatedRoutesAndPorts"
                        )
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }